import React, { useState } from "react";
import { Box, Button, Typography, CircularProgress } from "@mui/material";
import axios from "axios";

const TechSummitRegistrations = () => {
  const [loading, setLoading] = useState(false);

  const handleExport = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem("token");

      // API endpoint that returns registration data (CSV or Excel)
      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/api/admin/exportRegistrations`,
        {
          headers: { Authorization: `Bearer ${token}` },
          responseType: "blob", // Important for file downloads
        }
      );

      // Create a blob link to trigger download
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "tech_summit_registrations.csv");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Error exporting registrations:", err);
      alert("Failed to export registrations");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2 }}>
        Tech Summit Registrations
      </Typography>

      <Typography variant="body1" sx={{ mb: 2 }}>
        Click below to export all registrations from <strong>tech_summit_registrations</strong> table.
      </Typography>

      <Button
        variant="contained"
        color="primary"
        onClick={handleExport}
        disabled={loading}
      >
        {loading ? <CircularProgress size={24} sx={{ color: "#fff" }} /> : "Export Registrations"}
      </Button>
    </Box>
  );
};

export default TechSummitRegistrations;
